var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((parseInt(_vm.rating)),function(n){return _c('b-img',{key:n,attrs:{"src":"https://www.flaticon.com/svg/static/icons/svg/32/32724.svg","width":"15","alt":"Left image"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }